import { useEffect } from "react";

/* --------------------
 * usePreload
 * A custom hook to preload an image by adding a <link> tag to the document head.
 * This must match what's being used in the component so it caches correctly.
 *
 * @NOTE: Will not work with local URLs, only with base64 encoded strings.
 * @TODO: can esbuild be configured to handle local URLs?
 *
 * @param {string} imageAsString - base64 encoded image string.
 * -------------------- */
export const usePreload = (imageAsString: string) => {
  useEffect(() => {
    if (imageAsString === "") return;

    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = imageAsString;
    document.head.appendChild(link);
  }, [imageAsString]);
};
